import { render, staticRenderFns } from "./pkulogin.vue?vue&type=template&id=2b297c8f&scoped=true"
import script from "./pkulogin.vue?vue&type=script&lang=js"
export * from "./pkulogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b297c8f",
  null
  
)

export default component.exports